export default "/_next/static/chunks/fonts/HK Grotesk Bold Italic-9f612071fb7708de18d96893347c5574.otf";